import { Box } from '@chakra-ui/react';

const QuestionTemplate = ({ children, props }) => {

  const sectionName = props.stateProps.sectionData.sectionName;
  let maxWidth = sectionName === 'professional-experience' ? '1000px' : '800px';
  maxWidth = (sectionName.includes('interview'))  ? '100%' : maxWidth;
  const sxe = { width: '100%', maxWidth: maxWidth };
  return (

    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box sx={sxe}>
        {children}
      </Box>
    </Box>
  );
};

export default QuestionTemplate;
